'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./icon.scss');

var _index = require('./icons/index');

var _index2 = _interopRequireDefault(_index);

var _withTooltip = require('../with-tooltip/with-tooltip');

var _withTooltip2 = _interopRequireDefault(_withTooltip);

var _withColor = require('../with-color/with-color');

var _withColor2 = _interopRequireDefault(_withColor);

var _classnames = require('../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // eslint-disable-next-line


function Icon(_ref) {
  var className = _ref.className,
      name = _ref.name,
      size = _ref.size,
      inheritColor = _ref.inheritColor,
      props = _objectWithoutProperties(_ref, ['className', 'name', 'size', 'inheritColor']);

  var tooltip = props['data-tooltip'],
      propsToPropagate = _objectWithoutProperties(props, ['data-tooltip']);

  var style = { width: size + 'px', height: size + 'px' };
  var classes = (0, _classnames2.default)('icon', inheritColor && 'icon--use-current-color', size && 'icon--presized', className, props.onClick && 'icon--interactive');

  if (_index2.default[name] === undefined) {
    console.warn('There is no icon with name="' + name + '"');
    return null;
  }

  return _react2.default.createElement(
    'span',
    { className: classes, 'data-tooltip': tooltip, style: style },
    _index2.default[name](_extends({ width: size, height: size }, propsToPropagate))
  );
}

Icon.propTypes = {
  className: _propTypes2.default.string,
  name: _propTypes2.default.string,
  size: _propTypes2.default.string,
  inheritColor: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  'data-tooltip': _propTypes2.default.string
};

Icon.defaultProps = {
  inheritColor: true
};

exports.default = (0, _withColor2.default)((0, _withTooltip2.default)(Icon));